import styled from "styled-components";

export const HeroContainer = styled.div`
  margin-top: 80px;
  background: #000;
  display: flex;
  justify-content: center;
  align-item: center;
  height: 75vh;
  position: relative;
  z-index: 1;

  @media screen and (max-width: 1680px) {
  }
  @media screen and (max-width: 1280px) {
  }
  @media screen and (max-width: 980px) {
  }
  @media screen and (max-width: 736px) {
  }
  @media screen and (max-width: 480px) {
    height: 37.5rem;
  }
`;

export const HeroContent = styled.div`
  width: 100%;
  height: 100%;
`;

export const HeroH1 = styled.h1`
  color: #000;
  display: flex;
  font-size: 42px;
  text-align: left;
  position: relative;
  top: 1rem;
  font-weight: 300;
  text-transform: uppercase;
  font-family: Roboto;

  @media screen and (max-width: 1680px) {
  }
  @media screen and (max-width: 1280px) {
  }
  @media screen and (max-width: 480px) {
    font-size: 36px;
  }
`;

export const HeroP = styled.p`
  display: flex;
  color: #000;
  font-size: 24px;
  position: relative;
  text-align: left;
  font-weight: 500;
  max-width: 25rem;

  @media screen and (max-width: 1680px) {
  }
  @media screen and (max-width: 1280px) {
  }
  @media screen and (max-width: 980px) {
    font-size: 20px;
  }
  @media screen and (max-width: 480px) {
  }
`;

export const HeroH12 = styled.h1`
  color: #000;
  display: flex;
  font-size: 30px;
  text-align: center;
  position: relative;
  left: 15rem;
  top: 3rem;
  font-weight: 500;
  font-family: playfairDisplay !important;

  @media screen and (max-width: 768px) {
    font-size: 20px;
    position: relative;
    right: 11.8rem;
    top: 4rem;
  }
`;

export const HeroBtnWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
